import React, { forwardRef } from "react";
import ScrollLTR from "../scrollLTR/ScrollLTR";
import ScrollHorizontal from "../scrollHorizontal/ScrollHorizontal";
import classes from "./Scroll.module.css";

const Scroll = forwardRef(({ showDots = true, dropClass, height, downDropStyle, children, dataStyle, onScrollFunc, className = "" }, ref) => {

    const scrollProps = {
        dropClass,
        height,
        downDropStyle,
        dataStyle,
        onScrollFunc,
    };

    return (
        <div className={`${classes.Scroll} ${className}`}>
            <div className={classes.VerticalBranch}>
                <ScrollLTR ref={ref} {...scrollProps}>
                    {children}
                </ScrollLTR>
            </div>
            <div className={classes.HorizontalBranch}>
                <ScrollHorizontal ref={ref} {...scrollProps} className={className} showDots={showDots}>
                    {children}
                </ScrollHorizontal>
            </div>
        </div>
    );
});

export default Scroll;
